import { render, staticRenderFns } from "./ClienteListRoute.vue?vue&type=template&id=64716ecc&scoped=true"
import script from "./ClienteListRoute.vue?vue&type=script&lang=js"
export * from "./ClienteListRoute.vue?vue&type=script&lang=js"
import style0 from "./ClienteListRoute.vue?vue&type=style&index=0&id=64716ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64716ecc",
  null
  
)

export default component.exports